import React from 'react';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth } from 'web-common/src/shared/styles';

export interface IProps {
  as?: string;
  color?: Colors;
  fontSize?: string;
  mobileFontSize?: string;
  marginBottom?: string;
  textAlignMobile?: string;
  marginTop?: string;
}

export const ShefH1 = styled.h1<React.PropsWithChildren<IProps>>`
  font-family: ${Font.Family.SANS};
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : Colors.WHITE)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '80px')};
  line-height: 96px;

  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${(props) => (props.mobileFontSize ? props.mobileFontSize : '10vmin')};
    line-height: 10vmin;
  }
`;

export const ShefH2 = styled.h2<React.PropsWithChildren<IProps>>`
  font-family: ${Font.Family.SANS};
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : Colors.RADISH)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '40px')};
  line-height: 48px;
  margin-bottom: ${(props) => props.marginBottom || '50px'};
  margin-top: ${({ marginTop }) => marginTop || '0px'};

  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${(props) => (props.mobileFontSize ? props.mobileFontSize : '28px')};
    line-height: 34px;
    text-align: ${(props) => (props.textAlignMobile ? props.textAlignMobile : 'left')};
  }
`;

export const ShefH3 = styled.h3<React.PropsWithChildren<IProps>>`
  font-family: ${Font.Family.SANS};
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : Colors.GRAY_DARK_30)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '30px')};
  line-height: 40px;

  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${(props) => (props.mobileFontSize ? props.mobileFontSize : '20px')};
    line-height: 30px;
  }
`;

export const ShefH4 = styled.h4<React.PropsWithChildren<IProps>>`
  font-family: ${Font.Family.SANS};
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : Colors.GRAY_DARK_30)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '24px')};
  line-height: 29px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};

  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${(props) => (props.mobileFontSize ? props.mobileFontSize : '24px')};
    margin-top: 40px;
  }
`;
